(function () {
  if (window.__colourSiblingsHover) return;
  window.__colourSiblingsHover = true;

  if (!window.matchMedia('(hover: hover)').matches) return;

  // any colour swatch on a product card: sibling-product swatches and the theme's own variant swatches
  var SWATCH = '.product-block-options--swatch a.product-block-options__item';

  // hover-image layer styles (injected here so they exist on every page, not only where colour-sibling cards render)
  var css = document.createElement('style');
  css.textContent = '.cs-hover-img{position:absolute;inset:0;z-index:2;opacity:0;transition:opacity .2s ease;pointer-events:none;background:inherit}' +
    '.cs-hover-img img{width:100%;height:100%;object-fit:cover;display:block}.cs-hover-img.is-on{opacity:1}';
  document.head.appendChild(css);

  function getLayer(card) {
    var host = card.querySelector('.image-cont .image-label-wrap');
    if (!host) return null;
    var layer = host.querySelector('.cs-hover-img');
    if (!layer) {
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      layer = document.createElement('div');
      layer.className = 'cs-hover-img';
      layer.innerHTML = '<img alt="">';
      host.appendChild(layer);
    }
    return layer;
  }

  function setActive(card, swatch) {
    card.querySelectorAll(SWATCH).forEach(function (s) {
      s.classList.toggle('is-active', s === swatch);
    });
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest(SWATCH);
    if (!swatch) return;
    var card = swatch.closest('product-block');
    var layer = card && getLayer(card);
    if (!layer) return;
    setActive(card, swatch);
    if (swatch.hasAttribute('data-cs-self') || !swatch.dataset.csImg) {
      layer.classList.remove('is-on');
      return;
    }
    var img = layer.querySelector('img');
    if (img.getAttribute('src') !== swatch.dataset.csImg) img.src = swatch.dataset.csImg;
    img.alt = swatch.getAttribute('title') || '';
    layer.classList.add('is-on');
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('product-block');
    if (!card || card.contains(e.relatedTarget)) return;
    var layer = card.querySelector('.cs-hover-img');
    if (layer) layer.classList.remove('is-on');
    var self = card.querySelector(SWATCH + '[data-cs-self]');
    if (self) setActive(card, self);
  });
})();
